<template>
  <ActionModal
    v-model="data.open"
    title="Удалить интеграцию?"
    :actions="buttonsModal"
  />
</template>
<script lang="ts">
import {defineComponent, PropType} from "vue";
import {integrationItem, integrationList} from "./IntegrationTypes";
import ActionModal from "@/layout/nav/components/modal/modals/ActionModal/ActionModal.vue";
import {API} from "@/api/generated";
import type {operations} from "@/api/openapi";

type DeleteIntegrationName =
  operations["deleteIntegration"]["parameters"]["query"]["integration"];

const deleteIntegrationNames = [
  "email",
  "webSite",
  "telegram",
  "max",
  "bitrixCrm",
  "webhook",
  "ident",
  "macDent",
  "metric",
  "cbkiller",
  "domain",
  "amoCrm",
  "dentalPro",
  "google"
] as const satisfies readonly DeleteIntegrationName[];

const isDeleteIntegrationName = (name: string): name is DeleteIntegrationName =>
  (deleteIntegrationNames as readonly string[]).includes(name);

type DeleteModalData = {
  open: boolean;
  name: string;
  num: number;
};

export default defineComponent({
  name: "DeleteIntegration",
  components: {ActionModal},
  data() {
    return {};
  },
  props: {
    data: {
      type: Object as PropType<DeleteModalData>,
      required: true
    }
  },
  emits: ["close"],
  methods: {
    close() {
      this.$emit("close");
    },
    async deleteIntegration() {
      const {num, name} = this.data;

      if (!isDeleteIntegrationName(name)) {
        console.error("Неподдерживаемый тип интеграции:", name);
        return;
      }

      if (!this.getIntegration[name]) {
        console.error("Нет такой интеграции:", name);
        return;
      }

      if (!this.getIntegration[name].integration[num]) {
        console.error("Нет элемента:", num);
        return;
      }

      let id = "";
      const objIntegration = this.getIntegration[name].integration[num] as
        integrationItem | string;

      if (
        name === "amoCrm" &&
        typeof objIntegration === "object" &&
        "_id" in objIntegration
      ) {
        id = String(objIntegration._id);
      } else if (
        name === "dentalPro" &&
        typeof objIntegration === "object" &&
        "_id" in objIntegration
      ) {
        id = objIntegration._id;
      } else {
        if (
          ["domain", "email", "webSite"].includes(name) &&
          typeof objIntegration === "string"
        ) {
          id = objIntegration;
        } else if (
          typeof objIntegration === "object" &&
          "id" in objIntegration &&
          objIntegration.id
        ) {
          id = String(objIntegration.id);
        }
      }

      if (!id) {
        console.error("Не удалось определить id интеграции:", name, num);
        return;
      }

      id = encodeURIComponent(id);
      try {
        const res = await API.deleteIntegration({
          query: {
            integration: name,
            id
          }
        });
        await this.$integrationStore.fetchIntegrations(res);
        this.close();
      } catch (error) {
        console.error("Ошибка при удалении интеграции:", error);
      }
    }
  },
  computed: {
    getIntegration(): integrationList {
      return this.$integrationStore.getIntegration;
    },
    buttonsModal() {
      return [
        {
          text: "Отмена",
          handler: this.close
        },
        {
          text: "Удалить",
          handler: this.deleteIntegration
        }
      ];
    }
  }
});
</script>
